import * as THREE from 'three'
// import Scoll from 'views/Scoll'
let TWEEN = require('@tweenjs/tween.js')

let tubeGeometry
let tubeGeometryLook

class Scene6 {
  constructor (loadmodel) {
    let lineOutEnd = loadmodel.scene.getObjectByName('s6_lookat_1')
    let lineOutEnd2 = loadmodel.scene.getObjectByName('s5_lookat_1')
    let lineOut = []
    lineOut.push(loadmodel.camera.position)
    for (var c = 1; c < 20; c++) {
      let point = loadmodel.scene.getObjectByName('s5_out3_' + c)
      lineOut.push(point.position)
    }
    lineOut.push(lineOutEnd.position)
    let pipeSplineOut = new THREE.CatmullRomCurve3(lineOut)
    tubeGeometry = new THREE.TubeGeometry(pipeSplineOut, 64, 0.02, 8, false)

    // lookat
    let lineOutLook = []
    lineOutLook.push(lineOutEnd2.position)
    lineOutLook.push(lineOutEnd.position)
    let pipeSplineOutLook = new THREE.CatmullRomCurve3(lineOutLook)
    tubeGeometryLook = new THREE.TubeGeometry(pipeSplineOutLook, 12, 0.02, 8, false)
  }

  Popup (loadmodel) {
    var scene1tan = document.getElementById('scene_3')
    var scene2tan = document.getElementById('scene_4')
    scene2tan.style.display = 'block'
    scene1tan.style.display = 'none'
    var s1tishi1 = document.getElementById('s1_tishi_4')
    var text2 = document.getElementById('text_4')
    text2.innerHTML = ''
    s1tishi1.style.opacity = 0
    var blo1 = loadmodel.tween(s1tishi1.style).to({opacity: 1}, 2000).easing(TWEEN.Easing.Quartic.In).onStart(function () {
      s1tishi1.style.display = 'block'
      var str = '中国与世界更加互联互通,<br>一带一路再现古丝绸之路荣耀，<br>新四大发明讲述新的奇迹,<br>13亿人民在奋斗中追求幸福。'
      let i = 0
      let timer = setInterval(function () {
        if (i <= str.length) {
          text2.innerHTML = str.slice(0, i++) + '|'
        } else {
          clearInterval(timer)
          text2.innerHTML = str
        }
      }, 30)
    }).onComplete(function () {
      let touchstart = function () {
        s1tishi1.style.display = 'none'
        window.removeEventListener('touchstart', touchstart, false)
        window.removeEventListener('click', touchstart, false)
        back.style.display = 'block'
      }
      window.addEventListener('touchstart', touchstart, false)
      window.addEventListener('click', touchstart, false)
    })
    blo1.start()
    let raycaster = new THREE.Raycaster()
    let door = loadmodel.scene.getObjectByName('s6_door')
    let list = []
    for (var i = 0; i < 5; i++) {
      list.push(loadmodel.scene.getObjectByName('s6_dian' + i))
    }
    // 关 注册返回
    let that = this
    let back = document.getElementById('return')
    let goBack = function () {
      that.GoOut(loadmodel)
      back.removeEventListener('touchstart', goBack, false)
      back.removeEventListener('click', goBack, false)
      back.style.display = 'none'
    }
    back.addEventListener('click', goBack, false)
    back.addEventListener('touchstart', goBack, false)
    // 点 开门
    let touchend = function (e) {
      let mouse = new THREE.Vector2()
      mouse.x = (e.x / window.innerWidth) * 2 - 1
      mouse.y = -(e.y / window.innerHeight) * 2 + 1
      raycaster.setFromCamera(mouse, loadmodel.camera)
      let intersects = raycaster.intersectObject(door)
      if (intersects.length > 0) {
        // console.log('点到了场景4到场景1')
        loadmodel.tweenClear()
        loadmodel.EndControls()
        that.TouchStart(loadmodel)
        let back = document.getElementById('return')
        back.removeEventListener('touchstart', goBack, false)
        back.removeEventListener('click', goBack, false)
        back.style.display = 'none'
        // loadmodel.stats = 's6_1'
      }
      for (var j = 0; j < list.length; j++) {
        let intersects = raycaster.intersectObject(list[j])
        if (intersects.length > 0) {
          // console.log(j)
          var scene2tan = document.getElementById('scene_4')
          var len = scene2tan.getElementsByTagName('li')
          scene2tan.style.display = 'block'
          // console.log(len)
          for (var i = 0; i < len.length; i++) {
            len[i].style.display = 'none'
          }
          scene2tan.style.pointerEvents = 'auto'
          scene2tan.getElementsByTagName('li')[j].style.display = 'block'
        }
      }
    }
    let container = document.getElementById('container')
    container.addEventListener('click', function (event) {
      let point = new THREE.Vector2()
      point.x = event.clientX
      point.y = event.clientY
      touchend(point)
    }, false)
  }

  GoIn (loadmodel) {
    let tani = {t: 0.0, OldY: 0.0}
    let group = loadmodel.scene.getObjectByName('s6')
    group.visible = true
    let panoNew = loadmodel.scene.getObjectByName('s6_pano')
    panoNew.visible = true
    var go = loadmodel.tween(tani).to({t: 1.1}, 1000).easing(TWEEN.Easing.Quartic.In)
    go.start()
    loadmodel.sceneupdate = function () {
        // console.log(tani.t)
      var lookAt
      let lineOutEnd = loadmodel.scene.getObjectByName('s6_lookat_1')
      if (tani.t <= 1.09) {
        if (tani.t >= 0.1) {
          var pos = tubeGeometry.parameters.path.getPointAt(tani.t - 0.1)
          this.camera.position.copy(pos)
          lookAt = lineOutEnd.position
        } else {
          lookAt = tubeGeometryLook.parameters.path.getPointAt(tani.t * 10)
        }
        this.camera.lookAt(lookAt)
      } else {
        let lineOutEnd = loadmodel.scene.getObjectByName('s6_lookat_1')
        loadmodel.ChangeControls(lineOutEnd.position)
        loadmodel.sceneupdate = function () {}
        document.getElementById('close4').addEventListener('click', function (e) {
          e.preventDefault()
          this.parentNode.style.display = 'none'
          // this.parentNode.childNodes.style.display = 'none'
          // console.log(this.parentNode)
          // document.getElementById('scene_2').style.pointerEvents = 'none'
        })
      }
    }
  }

  GoOut (loadmodel) {
    loadmodel.EndControls()
    let tani = {t: 1.2}
    var go = loadmodel.tween(tani).to({t: 0}, 1000).easing(TWEEN.Easing.Quartic.In).onStart(function () {
      loadmodel.stats = 's4_b'
    })
    go.start()
    loadmodel.sceneupdate = function () {
      var lookAt
      let lineOutEnd = loadmodel.scene.getObjectByName('s6_lookat_1')
      let lineOutEnd2 = loadmodel.scene.getObjectByName('s5_lookat_1')
      if (tani.t > 0) {
        if (tani.t > 1.1) {
          let lineOut = []
          let end = tubeGeometry.parameters.path.getPointAt(0.99)
          lineOut.push(end)
          lineOut.push(loadmodel.camera.position)
          let pipeSplineOut = new THREE.CatmullRomCurve3(lineOut)
          let tubeGeometryCamera = new THREE.TubeGeometry(pipeSplineOut, 12, 0.02, 8, false)
          var pos = tubeGeometryCamera.parameters.path.getPointAt((tani.t - 1.1) * 10)
          this.camera.position.copy(pos)
          this.camera.lookAt(lineOutEnd.position)
        } else if (tani.t <= 1.1 && tani.t >= 0.1) {
          var pos2 = tubeGeometry.parameters.path.getPointAt(tani.t - 0.1)
          this.camera.position.copy(pos2)
          this.camera.lookAt(lineOutEnd.position)
        } else {
          lookAt = tubeGeometryLook.parameters.path.getPointAt(tani.t * 10)
          this.camera.lookAt(lookAt)
        }
      } else {
        let point = loadmodel.scene.getObjectByName('s5_out3_0')
        loadmodel.camera.position.copy(point.position)
        loadmodel.camera.lookAt(lineOutEnd2.position)
        loadmodel.ChangeControls(lineOutEnd2.position)
        loadmodel.sceneupdate = function () {}
      }
    }
  }

  TouchStart (loadmodel) {
    let tani = {t: 0}
    // console.log('点到了场景4到场景1')
    //  s6_out_1 出场动画
    // console.log(loadmodel)
    // let that = this
    let s6out1 = loadmodel.scene.getObjectByName('s6_out_1')
    let position1 = s6out1.position
    // console.log(position1)
    // console.log(loadmodel.camera.position)
    let lineOut = []
    lineOut.push(loadmodel.camera.position)
    lineOut.push(position1)
    let pipeSplineOut = new THREE.CatmullRomCurve3(lineOut)
    let tubeGeometry = new THREE.TubeGeometry(pipeSplineOut, 64, 0.02, 8, false)
    var go = loadmodel.tween(tani).to({t: 0.8}, 4000).easing(TWEEN.Easing.Exponential.Out)
    go.start()

    var html = document.getElementById('white')
    html.style.display = 'block'
    html.style.opacity = 0
    var dis_ = loadmodel.tween(html.style).to({opacity: 1}, 500).easing(TWEEN.Easing.Quartic.In).onComplete(function () {
      loadmodel.stats = 's6_1'
    })
    dis_.start()
    loadmodel.sceneupdate = function () {
      // console.log(tani.t)
      if (tani.t < 0.99) {
        let pos = tubeGeometry.parameters.path.getPointAt(tani.t)
        let lookat = tubeGeometry.parameters.path.getPointAt(tani.t + 0.01)
        loadmodel.camera.position.copy(pos)
        loadmodel.camera.lookAt(lookat)
      } else {
        loadmodel.sceneupdate = function () {}
      }
    }
  }
}
export default Scene6



// WEBPACK FOOTER //
// ./src/js/views/Scene6.js